var cashfreeProd = require('../dist/indexProd');
var cashfreeSandbox = require('../dist/indexSandbox');

module.exports = {
  cashfreeProd,
  cashfreeSandbox,
};